import * as React from 'react';

import styled from 'styled-components';

import { AnimatePresence } from 'framer-motion';

import Flex from '@components/layout/flex';
import LockIcon from '@components/basics/icons/lock';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import UnselectedIcon from '@components/basics/icons/unselected';
import Completed from '@components/basics/icons/achievements-icons/completed';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { push, CallHistoryMethodAction } from 'connected-react-router';

export interface RadioProps {
  className?: string;
  children?: any;
  isChecked?: boolean;
  isDark?: boolean;
  onChange: (active: boolean) => void;
  locked?: boolean;
  artistId: string;
  currentSubscriptionId: string;
  goToPlans: (clientId: string, id: string) => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  plan: state.subscription.current?.plan || '',
  currentSubscriptionId: state.subscription.current?.id || '',
  artistId: state.artist.active?.id || '',
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToPlans: (clientId: string, id: string) =>
    dispatch(push(`/plans/${clientId}/${id}`)),
});

export const Radio: React.FC<RadioProps> = (props) => {
  const { artistId, currentSubscriptionId } = props;

  const handleClick = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    ev.stopPropagation();
    props.onChange(!props.isChecked);
  };

  return (
    <Flex
      className={props.className}
      justifyContent="space-between"
      alignItems="center"
      onClick={(ev: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
        props.locked
          ? props.goToPlans(artistId, currentSubscriptionId)
          : handleClick(ev)
      }
    >
      <Typography
        weight="700"
        opacity={props.locked ? '.5' : '1'}
        className={`item-text  ${props.isDark ? 'dark' : null}`}
      >
        {props.children}
      </Typography>
      <AnimatePresence exitBeforeEnter>
        {props.locked ? (
          <div className="lock-icon">
            <LockIcon size={12} />
          </div>
        ) : props.isChecked ? (
          <MotionOpacity>
            <Completed className="icon-check" noAnimation />
          </MotionOpacity>
        ) : (
          <MotionOpacity>
            <UnselectedIcon
              isDark={props.isDark}
              className="icon-unselected"
              iconSize={24}
              noAnimation
            />
          </MotionOpacity>
        )}
      </AnimatePresence>
    </Flex>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(Radio)`
  cursor: pointer;

  .icon-check {
    width: 24px;
    height: 24px;
  }

  .icon-check,
  .icon-unselected {
    cursor: pointer;
  }

  .item-text {
    user-select: none;
  }

  .dark {
    color: ${({ theme }) => theme.colors.background};
  }

  .lock-icon {
    background-color: ${({ theme }) => theme.colors.primary};
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`);
